var StoryEvent = StoryEvent || {}

// 说完话事件
StoryEvent.SHOW_BLACK_SCREEN = "StoryEvent.SHOW_BLACK_SCREEN";

StoryEvent.READ_CONFIG_COMPLETE = "StoryEvent.READ_CONFIG_COMPLETE";

StoryEvent.STORY_OVER = "StoryEvent.STORY_OVER";

StoryEvent.PLAY_NEXT_ACT = "StoryEvent.PLAY_NEXT_ACT";

StoryEvent.SKIP_STORY = "storyevent.skip_story";

StoryEvent.UNIT_MORPH = "storyevent.unit_morph";

// 战斗结算面本关闭之后,解锁也显示完成之后
StoryEvent.BATTLE_RESULT_OVER = "StoryEvent.BATTLE_RESULT_OVER";

// 可以播放剧情和引导了
StoryEvent.PREPARE_PLAY_PLOT = "StoryEvent.PREPARE_PLAY_PLOT";

module.exports = StoryEvent;